import React, { useRef } from "react";
import { Link } from "react-router-dom";
import SimplebarReactClient from "../../SimplebarReactClient";
import {
  LuAlignJustify,
  LuBean,
  LuBike,
  LuCircle,
  LuConciergeBell,
  LuLayoutGrid,
  LuListOrdered,
  LuLogOut,
  LuPizza,
  LuSettings,
  LuStretchHorizontal,
  LuUserCog,
  LuZap,
} from "react-icons/lu";
import {
  logoDarkImg,
  logoLightImg,
  offerBgOtherImg,
} from "@/assets/data/images";
import VerticalMenu from "./VerticalMenu";
import { useDispatch } from "react-redux";
import { logout } from "../../../redux/authSlice";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import OfferAdBanner from "../../OfferAdBanner";

const MenuAdmin = () => {
  const dispatch = useDispatch(); // if you're using Redux
  const { t } = useTranslation(); // if you're using i18n
  const sidebarRef = useRef(null);
  const ADMIN_VERTICAL_MENU_ITEMS = [
    {
      key: "dashboard-page",
      label: t("sidebar.dashboard") || "Dashboard",
      icon: LuLayoutGrid,
      url: "/admin/dashboard",
      isTitle: true,
    },
    {
      key: "categories",
      label: t("sidebar.categories") || "Categories",
      icon: LuStretchHorizontal,
      url: "/admin/categories",
      isTitle: true,
    },
    {
      key: "ingrediens-page",
      label: t("sidebar.ingrediens") || "Ingrediens",
      icon: LuBean,
      url: "/admin/ingrediens",
      isTitle: true,
    },
    {
      key: "product-page",
      label: t("sidebar.products") || "Products",
      icon: LuConciergeBell,
      url: "/admin/products",
      isTitle: true,
    },
    {
      key: "clients-page",
      label: t("sidebar.clients") || "Clients",
      icon: LuUserCog,
      url: "/admin/clients",
      isTitle: true,
    },
    {
      key: "orders-page",
      label: t("sidebar.orders") || "Orders",
      icon: LuListOrdered,
      url: "/admin/orders",
      isTitle: true,
    },
    {
      key: "settings-page",
      label: t("sidebar.settings") || "Settings",
      icon: LuSettings,
      url: "/admin/settings",
      isTitle: true,
    },
    {
      key: "delivery-fee-ranges-page",
      label: t("sidebar.deliveryFee") || "Delivery Fee Ranges",
      icon: LuBike,
      url: "/admin/delivery-fee-ranges",
      isTitle: true,
    },
    {
      key: "pizza-dough-page",
      label: t("sidebar.pizzaDough") || "Pizza Dough",
      icon: LuCircle,
      url: "/admin/pizza-doughs",
      isTitle: true,
    },
    {
      key: "pizza-base-page",
      label: t("sidebar.pizzaBase") || "Pizza Base",
      icon: LuPizza,
      url: "/admin/pizza-bases",
      isTitle: true,
    },
  ];

  const handleLogout = async (event) => {
    event.preventDefault(); // Prevent the default link behavior
    dispatch(logout())
      .unwrap()
      .then(() => {
        toast.success("See you soon!", {
          position: "top-right",
          duration: 2000,
        });
        window.location.reload();
      })
      .catch((error) => {
        console.log("Logout failed", error);
        toast.error("An error occurred", {
          position: "top-right",
          duration: 2000,
        });
      });
  };

  return (
    <div
      id="application-sidebar"
      ref={sidebarRef}
      className={`hs-overlay fixed inset-y-0 start-0 z-[60] hidden w-64 -translate-x-full transform overflow-y-auto border-e border-default-200 bg-white transition-all duration-300 hs-overlay-open:translate-x-0 dark:bg-default-50 lg:bottom-0 lg:right-auto lg:block lg:translate-x-0 hide-in-print`}
    >
      <div className="sticky top-2 flex h-18 items-center justify-between border-b border-dashed border-default-200 px-6">
        <Link to="/admin/dashboard">
          <img
            src={logoDarkImg}
            height={60}
            width={100}
            alt="logo"
            className="dark:hidden"
          />
          <img
            src={logoLightImg}
            height={60}
            width={100}
            alt="logo"
            className="hidden dark:block"
          />
        </Link>
        <button
          type="button"
          className="flex lg:hidden text-default-500 hover:text-default-600"
          data-hs-overlay="#application-sidebar"
          aria-controls="application-sidebar"
          aria-label="Toggle navigation"
        >
          <LuAlignJustify size={24} />
        </button>
      </div>

      <SimplebarReactClient className="h-[calc(100%-390px)]">
        <VerticalMenu menuItems={ADMIN_VERTICAL_MENU_ITEMS} />
      </SimplebarReactClient>

      <ul className="admin-menu flex flex-col gap-2 px-4 pt-10">
        <li className="menu-item">
          <div
            style={{ backgroundImage: `url(${offerBgOtherImg})` }}
            className="flex flex-col items-center rounded-md bg-primary/5 bg-cover bg-no-repeat p-4 text-center text-sm text-default-700"
          >
            <div className="-mt-10 mb-4 flex h-16 w-16 items-center justify-center rounded-full border border-default-100 bg-white text-primary shadow-lg dark:bg-default-50">
              <LuZap size={24} />
            </div>
            <p className="mb-4 text-sm text-default-700">{t("sidebar.text")}</p>
          </div>
        </li>

        <li className="menu-item">
          <div
            className="flex items-center gap-x-3.5 rounded-md px-4 py-3 text-sm text-red-500 hover:bg-red-400/10 hover:text-red-600"
            onClick={handleLogout}
          >
            <LuLogOut size={20} />
            {t("sidebar.logout") || "Logout"}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default MenuAdmin;
